<template>
  <header class="hero-section display">
    <div class="container">
      <div class="hero-tags">
        <span v-for="tag in homeData.expertise" :key="tag">{{ tag }}</span>
      </div>
      <div>
        <h1>{{ homeData.name }}</h1>
        <p>{{ homeData.bio }}</p>
      </div>
      <ContactLinks />
    </div>
  </header>
</template>

<script setup lang="ts">
import { homeData } from "../../../home.config";
import ContactLinks from "../homepage/ContactLinks.vue";
</script>

<style scoped lang="scss">
@use "../../styles/abstracts/breakpoints" as *;

.hero-section {
  text-align: center;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: var(--space-xl);

  @include lg {
    padding: var(--space-4xl) 0;
    gap: var(--space-2xl);
    margin-bottom: var(--space-2xl);
  }
}

.hero-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  gap: var(--space-md);
  margin-bottom: var(--space-lg);

  @include sm {
    gap: 1em;
  }

  span {
    white-space: nowrap;
  }
}

.container {
  margin: 0 auto;
  max-width: var(--content-width-default);
}
</style>
